module.exports = __webpack_public_path__ + "static/images/mall-kg-bg.1bb6396.png";